// components/upload/upload-drawer-file.tsx
import React, { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { nanoid } from "nanoid";
import { authState } from "@/atoms/auth";
import { Document } from "@/types/entities";
import { HttpAgent, Actor } from '@dfinity/agent';
import { idlFactory } from './services/recognition-backend.did';
import { useNavigate } from "react-router-dom";
import { documentState, createDocument } from "@/atoms/document";

export const useAnalyzeDocument = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isAnalyzing, setIsAnalyzing] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [uploadSuccess, setUploadSuccess] = useState<boolean>(false);
    const setAssets = useSetRecoilState(documentState);
    const [user] = useRecoilState(authState);
    const navigate = useNavigate();

    const startAnalysis = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        if (!file) {
            setError("No file selected");
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            setError("File size should not exceed 10 MB");
            return;
        }

        if (!user) {
            setError("User not authenticated");
            return;
        }

        setError(null);
        setUploadSuccess(false);
        setIsLoading(true);
        setIsAnalyzing(false);

        try {
            const docKey = nanoid();
            const assetKey = await createDocument(file, setAssets, docKey);

            setIsLoading(false);
            setIsAnalyzing(true);

            const canisterId = import.meta.env.VITE_RECOGNITION_BACKEND as string;
            const agent = new HttpAgent({ host: 'https://ic0.app' });
            const actor = Actor.createActor(idlFactory, { agent, canisterId });
            const gptResponse: string = await actor.send_image_url_to_proxy(assetKey.imageUrl) as string;
            console.log("gptResponse", gptResponse)
            let resultText = JSON.parse(gptResponse).choices[0].message.content;

            let index = resultText.indexOf("{");
            resultText = resultText.slice(index);
            index = resultText.indexOf("}");
            resultText = resultText.slice(0, index + 1);
            console.log("resultText", resultText)
            const result = JSON.parse(resultText);
            const analysisResult = { ...result, source: 'document_upload' }
            console.log("analysisResult", analysisResult)

            // Create a document based on the analysed result
            const newDocument: Document = {
                id: docKey,
                title: file.name,
                type: file.type.split("/").pop() as "pdf" | "csv" | "txt", // Determine the file type
                content: analysisResult.content,
                uploaded_at: new Date().toISOString(),
                owner_id: user.key,
            }
            console.log("newDocument", newDocument)
            await createDocument(newDocument, setAssets, docKey);

            setUploadSuccess(true);
        } catch (error) {
            console.error("Error during analysis:", error);
            setError("Error during analysis");
        } finally {
            setIsAnalyzing(false);
        }
    };

    return {
        startAnalysis,
        isLoading,
        isAnalyzing,
        error,
        uploadSuccess,
    };  
}